module.exports = __webpack_public_path__ + "img/plumber_demo.2f0fbaa3.jpg";